import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../../facturotopia';

class NominaPercepcionesJubilacionPensionRetiroForm extends Component {

  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    }

    this.rules = props.rules;
  }

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (values) => {
    const data = {
      ...this.props.data,
      ...values
    };

    const validator = this.validate(data);

    this.props.onChange({
      data,
      isValid: validator.passes()
    });
  }

  render() {
    const rules = this.rules;
    const { data = {} } = this.props;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Total Una Exhibicion"
              name="TotalUnaExhibicion"
              placeholder=""
              help=""
              min="0"
              rules={ rules.TotalUnaExhibicion }
              value={ data.TotalUnaExhibicion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Total Parcialidad"
              name="TotalParcialidad"
              placeholder=""
              help=""
              rules={ rules.TotalParcialidad }
              value={ data.TotalParcialidad }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Monto Diario"
              name="MontoDiario"
              placeholder=""
              help=""
              min="0"
              rules={ rules.MontoDiario }
              value={ data.MontoDiario }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Ingreso Acumulable"
              name="IngresoAcumulable"
              placeholder=""
              help=""
              min="0"
              rules={ rules.IngresoAcumulable }
              value={ data.IngresoAcumulable }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Ingreso No Acumulable"
              name="IngresoNoAcumulable"
              placeholder=""
              help=""
              min="0"
              rules={ rules.IngresoNoAcumulable }
              value={ data.IngresoNoAcumulable }
              onChange={ this.handleOnChange }
            />
          </Col>

        </Row>

        <Row>
          <Col>
            <div className="text-muted">
              Cuando selecciones una percepción con las siguientes claves es necesario que especifiques los detalles de Jubilacion Pensión Retiro:

              <ul>
                <li>"039" Jubilaciones, pensiones o haberes de retiro en una exhibición</li>
                <li>"044" Jubilaciones, pensiones o haberes de retiro en parcialidades</li>
              </ul>
            </div>
          </Col>
        </Row>

      </>
    )
  }
}

export default NominaPercepcionesJubilacionPensionRetiroForm;